export const capitalizeText = (text) => {
  if (typeof text !== 'string' || text.length === 0) return '';
  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const isTruthyFlag = (value) => value === true || value === 1 || value === '1' || value === 'true';

export const filterDashboardEnumOptions = (options = [], flagKeys) =>
  options.filter((opt) => {
    if (!flagKeys) return true;
    const keys = Array.isArray(flagKeys) ? flagKeys : [flagKeys];
    const presentKeys = keys.filter((key) => Object.prototype.hasOwnProperty.call(opt, key));
    if (presentKeys.length === 0) return false;
    return presentKeys.some((key) => isTruthyFlag(opt[key]));
  });

export const buildDashboardEnumOptions = (options = [], flagKey) =>
  filterDashboardEnumOptions(options, flagKey).map((opt) => ({
    value: Number.isNaN(Number(opt.label)) ? opt.label : Number(opt.label),
    label: capitalizeText(opt.value),
  }));
